import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useAuth } from 'hooks/useAuth';

import { createOnboardingPlaylistIfPresent } from 'store/modules/onboardingPlaylist';

export const useCreateOnboardingPlaylistAfterSignIn = () => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      dispatch(createOnboardingPlaylistIfPresent());
    }
  }, [dispatch, user]);
};
